import { copyFile } from 'fs';

export default {
	userLogin: {
		uNamePlaceholder: '账号、邮箱或手机号',
		uNameRule: '请输入账号、邮箱或手机号',
		pWPlaceholder: '请输入密码',
		passWordRule: '请输入数字+英文字母（需包含大小写），6-20位',
		passWordRule1: '请输入数字+英文字母（需包含大小写），8-20位',
		codeRule: '验证码为6位数字',
		forgetPwd: '忘记密码',
		confirm: '确定',
		setPwd: '数字+字母（包含大小写），6-20位',
		setPwd1: '数字+字母（包含大小写），8-20位',
		pwd: '输入密码',
		setAgainPwd: '再次输入密码',
		confirmPwd: '密码不一致',
		clickConfirm: '点击完成验证',
		confirmSuccess: '验证成功',
		again: '重新获取',
		againPass: '{time}秒后可重发',
		move: '请按住滑块拖动',
		loginInfo: ' 未注册的手机号将自动注册。勾选即代表您同意并接受',
		loginAccInfo: '阅读并同意',
		service: '服务协议',
		and: '和',
		security: '隐私政策',
		bindPhone: '绑定手机号',
		bindInfo: '您的企业微信暂未绑定手机号，请绑定后使用',
		bindInfo1: '您的微信暂未绑定手机号，请绑定后使用',
		bind: '绑定',
		otherWayLogin: '其他方式登录',
		copyright: '北京中科闻歌科技股份有限公司 ©2023 版权所有',
		icp: '京ICP备17022028号',
		webNum: '网信算备110108009321501240027号',
		webCode: '京公网安备 11010802034536号',
		phoneInfo: '请输入正确的手机号',
		noPermission: '抱歉，您没有登录权限',
		codeErr: '获取验证码失败',
		codeContinue: '验证失败，请重试',
		slidConfirm: '请拖动滑块进行验证',
		errMsg: '请求失败',
		checkInfo: '请同意并勾选服务协议和隐私政策',
		loginFail: '登录失败，请重试',
		webErr: '网络错误',
		codeInfo: '请输入验证码',
		bindFail: '绑定失败，请重试',
		ways: '其他登录方式',
		getCode: '获取验证码',
		oladPassInfo: '请输入旧密码',
		clear: '清除成功！',
	},
	loginWays: {
		phone: '短信登录',
		qChat: '企微登录',
		password: '密码登录',
		wechat: '微信登录',
	},
	setting: {
		unbind: '解绑',
		unbind1: '未绑定',
		unBindInfo: '解绑成功',
		setPwd: '修改密码',
		baseInfo: '基础信息',
		userId: '账户ID',
		phone: '手机号',
		user: '账号',
		password: '密码',
		email: '电子邮箱',
		qchat: '企业微信',
		bind: '去绑定',
		time: '注册时间',
		codeBind: '扫码绑定',
		oldPwdPassword: '请输入原密码',
		newPwd: '请输入新密码',
		newAgainPwd: '请再次输入新密码',
		forgetInfo: '为了保证您的账号安全，请验证身份。认证成功后进行下一步操作。',
		findPwd: '找回密码',
		resetPwd: '重置密码',
		finsh: '完成',
		copySuccess: '复制成功',
		pwdSuccess: '密码修改成功',
		bindSuccess: '绑定成功',
		accountSuccess: '账号修改成功',
		eamilInput: '请输入正确的邮箱',
		emailSuccess: '邮箱修改成功',
		nameInput: '名称不能为空',
		nameSuccess: '昵称修改成功',
		confirmPwd: '确认密码',
		adminSetPwd: '设置管理员密码',
		adminPwd: '管理员密码',
		singOut: '注销账户',
		info1: '注销账户将永久失效且不可恢复',
		info2: '以下信息将被清空且无法找回',
		info3: '· 您账户下的全部对话记录',
		info4: '· 您创建的智能体信息',
		logout: '注销成功',
	},
	user: {
		nickName: '昵称',
		userManage: '用户管理',
		userType: '用户类型',
		balckLists: '黑名单',
		role: '角色',
		placeholdKeyW: '请输入关键词',
		add: '新增',
		account: '账号',
		userName: '用户名',
		wgRole: '闻歌员工',
		otherRole: '外部客户',
		time: '有效期',
		loinTime: '注册时间',
		loginTime: '最近登录',
		wordTest: '敏感词检测',
		open: '开启',
		close: '关闭',
		operation: '操作',
		edit: '编辑',
		delete: '删除',
		logOut: '注销',
		defriend: '拉黑',
		relieve: '解除',
		askLog: '问答记录',
		resetPwd: '重置密码',
		addUser: '添加用户',
		editUser: '编辑用户',
		accountPlaceHold: '请输入账号',
		accountInfo: "账号不能是纯数字，且不能包含{'@'}",
		require: '必填项',
		input: '请输入',
		email: '邮箱',
		user: '用户',
		abUser: '普通用户',
		admin: '管理员',
		validTime: '有效时间',
		vip: 'vip权限',
		endTime: '截止时间',
		vipTime: 'VIP到期时间',
		remark: '备注',
		cancel: '取消',
		confirm: '确定',
		yes: '是',
		no: '否',
		resetSuccess: '重置成功',
		warning: '提示',
		confirmDelete: '确定删除',
		deleteMsg: '删除成功',
		leaveMsg: '离线成功',
		operateMsg: '操作成功',
		addMsg: '添加成功',
		editMsg: '编辑成功',
		edmitMsg: '提交失败',
		third: '第三方账号',
		setNick: '修改昵称',
		setEmail: '修改邮箱',
		setAccount: '修改账号',
		pwd: '密码',
		loginReset: '该设备登录已失效',
		loginInfo: '你当前的账号登录已失效,{second}s后自动进入新账号',
		timeInfo: '{second}s自动进入',
		loginAgainInfo: '请重新登录',
		loginAgain: '重新登录',
		setPwd: '设置密码',
		payFail: '支付失败',
		paySuccess: '支付成功',
		serviceGift: '系统赠送',
		paySuccessTip1: '上次服务结余',
		paySuccessTip2: ',扣除后的总余额为',
		paySuccessTip3: ',请知悉',
		clearPwd: '清空管理员密码',
		confirmClear: '确定清除管理员密码？',
		free: '免费用户',
		vipSelect: '付费订阅',
		placeVip: '订阅计划',
		api: 'API服务',
		apiName: '获取雅意API接口开发文档（含本账号专属令牌）',
		apiBtn: '获取',
		apiInfo: '已发送到邮箱',
		msgInfo: '请在基础信息中填写有效电子邮箱后获取',
		timeInfo2: '获取（{t}s）',
	},
	personal: {
		dataReview: '数据总览',
		userId: '账号ID',
		select: '请选择',
		technology: '指令调用情况',
		useTotal: '调用统计',
		unit: '单位：次',
		serviceTotal: '服务调用统计',
		unitTimes: '共计/次',
		custom: '最近消耗',
		customInfo: '费用说明',
		info: '提示',
		tokenInfo: '1 token 约等于 1.25 字符',
		equal: '约等于',
		customDetail: '消费明细',
		unitYuan: '单位：元',
		unitToken: '单位：tokens',
		difference: '当前剩余tokens',
		arrears: '当前欠费tokens',
		total: '总计充值',
		give: '赠送',
		yuan: '元',
		pay: '去充值',
		payDetail: '充值明细',
		paySituation: '充值情况',
		app: '应用',
		accountPay: '账户充值',
		moneyInfo: '1.请确保账户有足够金额进行交易。',
		thirInfo: '2.充值过程遇到交易问题，请前往相应的第三方支付平台确认。',
		checkInfo: '3.充值完成后，可前往充值管理-充值明细中查看交易记录，账户总览中查看账户余额。',
		canUse: '可用余额',
		payWay: '支付平台',
		payTotal: '充值金额',
		payConfiem: '确认充值',
		payInfo: '确认支付即代表同意本平台',
		payFinish: '已完成支付',
		zfbPay: '支付宝支付',
		wechatPay: '微信支付',
		realPay: '实付',
		scanPay: '打开支付宝扫描二维码完成支付',
		payService: '充值协议',
		zfb: '支付宝',
		wechat: '微信',
		servicesInfo: '请勾选 “确认支付即代表同意本平台《充值协议》”',
		payChoice: '请选择充值金额',
		paySuccess: '您已充值成功，充值数额等详细信息请在',
		payCheck: '里查看',
		userType: '用户类型',
		payStatu: '支付状态',
		payWays: '支付方式',
		placeHold: '请输入用户名/订单编号',
		placeHold1: '请输入订单编号',
		export: '导出',
		number: '订单编号',
		userName: '用户名',
		money: '充值金额（元）',
		giveMoney: '购买tokens',
		time: '充值时间',
		systeamGiven: '系统赠送',
		success: '成功',
		fail: '失败',
		categoryPlace: '全部分类',
		technologyPlace: '全部指令',
		useTime: '调用时间',
		category: '分类',
		techno: '指令',
		serName: '服务名称',
		userTimes: '调用次数',
		toekn: '消费token',
		price: '单价',
		customInfos: '费用说明',
		customTotal: '消费金额（元）',
		totalTimes: '总调用次数',
		placehold2: '输入手机号查询单用户调用数据',
		noData: '暂无记录',
		useUnit: '调用：次',
		useToken: '调用量：token',
		skillList: '指令列表',
		defineMoney: '自定义金额',
		readInfo: '请同意并勾选服务协议和隐私政策',
		editSuccess: '修改成功',
		setSuccess: '密码修改成功，需重新登录',
		selectAgent: '请选择智能体',
		addApplication: '新增应用',
		applyName: '应用名称',
		appNodata: '暂无智能体',
		smartAgent: '智能体',
		releaseDate: '发布时间',
		link: '链接',
		pubSuccess: '已复制发布链接',
		isEnabled: '是否启用',
		conversationRecord: '对话记录',
		rename: '重命名',
		disableSmartAgentApp: '停用智能体应用',
		disableDescription: '停用后，该应用对应链接将失效，其他用户将无法通过链接继续与该智能体对话。',
		selectSmartAgentToPublish: '请选择发布的智能体',
		public: '公开',
		shareToMe: '分享给我',
		my: '我的',
		publish: '发布',
		enabled: '已启用',
		disabled: '已停用',
		enterName: '请输入名称',
		application: '应用',
		conversation: '对话',
		work: '作品',
		enterApplicationName: '请输入应用名称',
		selectVisitor: '请选择访问者',
		visitor: '访问者',
		ipAddress: 'IP地址',
		visitorConversationCreateTime: '访问对话创建时间',
		view: '查看',
		viewConversationRecord: '查看对话记录',
		workCreateTime: '作品创建时间',
		generating: '生成中',
		generationFailed: '生成失败',
		generationCompleted: '生成完成',
		status: '状态',
		type: '生成插件',
		longText: '详情',
		creditsCenter: '研值中心',
		creditsRule: '研值规则说明',
		creditsDesc: '当前研值/累计研值',
		consume: '已消耗{total}研值',
		invite: '邀请好友得研值',
		inviteDesc: '每邀请一位新用户',
		credits: '研值',
		inviteLink: '邀请链接',
		inviteUser: '累计邀请',
		getCreDits: '已获研值',
		inviteRule: {
			title: '邀请规则说明',
			content1: '每成功邀请一位新用户注册并完成实名认证，即可获得',
			reward: '奖励',
			rewardIssue: '奖励发放',
			content2: '邀请奖励将在被邀请用户完成注册后 24 小时内自动发放到您的账户',
			notes: '注意事项',
			note1: '- 邀请用户需要是首次注册平台的新用户',
			note2: '- 对于恶意注册或违规行为，平台有权撤销相应奖励',
			note3: '- 邀请链接仅限本人使用，请勿用于非法用途',
		},
		researchValue: {
			researchValueTitle: '研值规则说明',
			whatIsResearchValue: '什么是研值？',
			whatIsResearchValueDesc:
				'研值是平台的核心积分体系，用于衡量用户的研究能力和活跃度。通过完成各类研究任务和学术活动来获取研值，解锁更多高级功能和权益',
			earnResearchValueTitle: '研值获取',
			earnByInvited: '被好友邀请',
			earnByInviting: '邀请好友',
			perPerson: '人',
			consumeResearchValueTitle: '研值消耗',
			generateReview: '生成研究综述',
			useFastMode: '使用极速模式',
			useResearchMode: '使用研究模式',
			times: '次',
			specialNoteTitle: '特别说明',
			specialNote1: '研值有效期为一年，请及时使用',
			specialNote2: '禁止违规刷研值，违者将被清零并封禁账号',
			specialNote3: '平台保留对研值规则的最终解释权',
		},
		creditsDetails: '研值明细',
		incomeRecord: '收入记录',
		outcomeRecord: '支出记录',
		copyTip: '邀请链接已复制到剪切板，快点贴给好友吧~',
	},
	router: {
		creditsCenter: '研值中心',
		personalCenter: '个人中心',
		personalPublic: '发布管理',
		accountOverview: '账户总览',
		rechargeManagement: '充值管理',
		accountRecharge: '账户充值',
		rechargeDetails: '充值明细',
		consumptionDetails: '消费明细',
		callStatistics: '调用统计',
		accountSettings: '账户设置',
		backendManagement: '后台管理',
		dataStatistics: '数据统计',
		overview: '总览',
		userManagement: '用户管理',
		applicationManagement: '申请管理',
		YAYIChat: 'YAYIChat',
		YAYILit: 'YAYILit',
		skillApplicationManagement: '指令应用管理',
		skillCategoryManagement: '指令分类管理',
		likeAndDislikeManagement: '赞踩管理',
		QAndARecords: '问答记录',
		YAYIFile: 'YAYIFile',
		knowledgeBaseManagement: '知识库管理',
		login: '登录',
		trialApplication: '试用申请',
		serviceAgreement: '服务协议',
		privacyPolicy: '隐私政策',
		advancedSetting: '高级设置',
	},
	manage: {
		totalUser: '用户总数',
		individual: '个人',
		enterprise: '企业',
		totalCall: '总调用次数',
		errorCall: '调用失败次数',
		dataOverview: '数据总览',
		pleaseSelect: '请选择',
		all: '全部',
		rechargeStatus: '充值情况',
		rechargeDetails: '充值明细',
		currencyUnit: '单位：元',
		skillCallStatus: '指令调用情况',
		callStatistics: '调用统计',
		timesUnit: '单位：次',
		serviceCallStatistics: '服务调用统计',
		TotalAndCount: '共计/次',
		userTypes: '用户类型',
		paymentStatus: '支付状态',
		paymentStatusTitle: '支付状态',
		PaymentMethods: '支付方式',
		userAndOrderPlaceholder: '请输入用户名/订单编号',
		orderPlaceholder: '请输入订单编号',
		export: '导出',
		orderNumber: '订单编号',
		userName: '用户名',
		rechargeAmount: '充值金额（元）',
		bonusAmount: '购买tokens',
		rechargeTime: '充值时间',
		paymentMethod: '支付方式',
		systemGift: '系统赠送',
		wechat: '微信',
		aliPay: '支付宝',
		success: '成功',
		failure: '失败',
		callDataPlaceholder: '输入手机号查询单用户调用数据',
		noRecord: '暂无记录',
		skillList: '指令列表',
		amountUnit: '调用量：token',
		numberUnit: '单位：次',
		userManagement: '用户管理',
		blacklist: '黑名单',
		role: '角色',
		keywordPlaceholder: '请输入关键词',
		add: '新增',
		newUser: '新增',
		phoneNumber: '手机号',
		staff: '闻歌员工',
		customer: '外部客户',
		validDuration: '有效期',
		registrationTime: '注册时间',
		lastLogin: '最近登陆',
		sensitiveWordDetection: '敏感词检测',
		enable: '开启',
		disable: '关闭',
		operation: '操作',
		edit: '编辑',
		delete: '删除',
		block: '拉黑',
		remove: '解除',
		QAndARecords: '问答记录',
		addUser: '添加用户',
		editUser: '编辑用户',
		phonePlaceholder: '请输入手机号',
		required: '必填项',
		placeholder: '请输入',
		email: '邮箱',
		user: '用户',
		generalUser: '普通用户',
		admin: '管理员',
		validDuration2: '有效时间',
		remarks: '备注',
		cancel: '取消',
		confirm: '确定',
		yes: '是',
		no: '否',
		blocked: '是',
		notBlocked: '否',
		phoneValidPlaceholder: '请输入正确的手机号',
		emailValidPlaceholder: '请输入正确的邮箱',
		confirmTitle: '提示',
		sureDelete: '确定删除',
		deletionSuccessful: '删除成功',
		offlineSuccessful: '离线成功',
		operationSuccessful: '操作成功',
		additionSuccessful: '添加成功',
		editSuccessful: '编辑成功',
		createSuccessful: '新建成功',
		submissionFailed: '提交失败',
		applicationManagement: '申请管理',
		industry: '所属行业',
		industryTitle: '所属行业',
		approvalStatus: '审核状态',
		name: '姓名',
		companyName: '公司名称',
		businessScenario: '业务场景',
		source: '来源',
		serviceObject: '服务对象',
		internal: '内部',
		external: '外部',
		applicationTime: '申请时间',
		status: '状态',
		toBeApproved: '待审核',
		approved: '已通过',
		rejected: '已拒绝',
		review: '审核',
		auditResult: '审核',
		approvalResult: '审批结果',
		invitationCode: '邀请码',
		emailSent: '已通过且发送邮件',
		emailSent2: '通过且发送邮件',
		reason: '理由',
		sending: '发送中',
		submit: '提交',
		rejectReason: '拒绝原因',
		optional: '非必填',
		reject: '拒绝',
		sendSuccessful: '发送成功',
		invalidEmail: '邮箱无效',
		skillApplicationManagement: '指令应用管理',
		roleQuery: '角色查询',
		category: '所属分类',
		categoryTitle: '所属分类',
		skillID: '指令ID',
		skillName: '指令名称',
		recommendedSkill: '推荐指令',
		example: '示例',
		permission1: '权限',
		permission: '权限',
		public: '公开',
		private: '私有',
		creationTime: '创建时间',
		creator: '创建人',
		enable2: '上线',
		disable2: '下线',
		disableTheSkill: '确定下线？',
		newSkill: '新增',
		addSkill: '新增指令',
		editSkill: '编辑指令',
		pleaseEnterTheSkillName: '请输入指令名称',
		beta: '是否标记beta',
		pleaseSelectTheCategory: '请选择所属分类',
		moreThanOneOption: '多选项',
		skillIntroduction: '指令简介',
		pleaseEnterTheTemplateContent: '请输入模板内容',
		backgroundRole: '背景角色',
		recommendedQuestions: '推荐问题',
		promptEmptyPlaceholder: '请输入Prompt',
		variable: '变量',
		variablePlaceholder: '请输入变量示例值',
		noData: '暂无数据',
		creativity: '创造力',
		save: '保存',
		saveAndPublish: '保存并发布',
		debug: '调试',
		promptPreview: 'Prompt 预览',
		promptPreviewTip: '左侧输入Prompt即可实时预览',
		run: '运行',
		result: '结果',
		time: '耗时',
		takeToken: '花费Token',
		generateResult: '结果生成中...',
		variableName: '变量名',
		type: '类型',
		string: '字符串',
		publishSuccessful: '发布成功',
		takenDownSuccessful: '下架成功',
		copySuccessful: '复制成功',
		deleteSkill: '您确定要删除该指令吗？',
		deleteSkillAlert: '删除后指令将无法恢复，请谨慎操作',
		skillCategoryManagement: '指令分类管理',
		categoryID: '类目ID',
		categoryName: '类目名称',
		description: '描述',
		addCategory: '新增分类',
		editCategory: '编辑分类',
		pleaseEnterTheCategoryName: '请输入类目名称',
		thumbsUpAndDownQA: '智能问答赞踩',
		thumbsUpAndDownType: '赞踩类型',
		thumbsUpAndDownTypeTitle: '赞踩类型',
		keywordOrPhone: '请输入关键词/手机号',
		thumbsUp: '点赞',
		thumbsDown: '点踩',
		category2: '分类',
		feedback: '赞踩反馈',
		feedbackTitle: '赞踩反馈',
		QAndA: '问题、答案及参数',
		applicationAndParameters: '应用及参数',
		IPAddress: 'IP地址',
		userAgent: 'userAgent',
		userPhoneNumber: '用户手机',
		feedbackUser: '反馈用户',
		toBeReviewed: '未审核',
		approved2: '已赞同',
		disapproved: '不赞同',
		application: '应用',
		applicationParameters: '应用参数',
		reasonsForDisagreement: '不赞同的原因',
		thumbsUpDownManagement: '赞踩管理',
		likeAndDislikeManagement: '赞踩管理',
		feedbackTime: '反馈时间',
		approvalResult2: '审核结果',
		IntelligentQAndALog: '智能问答记录',
		category3: '应用行业',
		category3Title: '应用行业',
		sensitive: '是否敏感',
		sensitiveTitle: '是否敏感',
		YaYiInputParameter: 'YaYi入参',
		prompt: '提示词',
		calledPlugin: '调用插件',
		pluginOutput: '插件输出',
		notSensitive: '不敏感',
		sensitive2: '敏感',
		time2: '时间',
		category4: '应用类型',
		target: '目标',
		knowledgeBaseManagement: '知识库管理',
		keywordAndUser: '请输入知识库关键词/用户手机号',
		knowledgeBaseID: '知识库ID',
		knowledgeBaseName: '知识库名称',
		knowledgeBaseNameTitle: '知识库名称',
		publiclyAccessible: '全部公开',
		internallyAccessible: '对内公开',
		numberOfFiles: '文件数',
		wordCount: '字数统计',
		expand: '扩容',
		addKnowledgeBase: '新增知识库',
		editKnowledgeBase: '编辑知识库',
		pleaseEnterTheKnowledgeBaseName: '请输入知识库名称',
		icon: '图标',
		description2: '简介',
		brieflyDescribe: '请简单介绍下这个知识库',
		deleteKnowledgeBase: '您确定要删除该知识库吗？',
		deleteKnowledgeBaseAlert: '删除后知识库将无法恢复，请谨慎操作。',
		comingSoon: '敬请期待',
		knowledgeBaseQAndA: '知识库问答赞踩',
		likeAndDislikeType: '赞踩类型',
		likeAndDislikeTypeTitle: '赞踩类型',
		knowledgeBaseQAndALogs: '知识库问答记录',
		searchResult: '检索结果',
		searchParameter: '检索参数',
		knowledgeBase: '知识库',
		userPrivate: '私有',
		permissionType: '类型',
		newRepo: '新增',
		userAdd: '新增',
		account: '账号',
		tableuserName: '用户名',
		userType: '用户类型',
		tabletime: '有效期',
		normalUser: '正常用户',
		deletedUser: '已删除用户',
		logoutUser: '注销用户',
		blockUser: '拉黑用户',
		haveDeleted: '已删除',
		haveLogOut: '已注销',
		emaillInfo: '请输入正确的邮箱格式',
		aiDraw: 'AI绘画',
		experience: '体验模式',
		longFile: '长文档',
		graphicsSelection: '图形选择',
		backgroundColor: '背景颜色',
	},
	log: {
		manageLog: '安全审计',
	},
};
